/**
 * Capability registry — TypeScript mirror of `backend/rbac/capabilities.js`.
 *
 * Each leaf is a `path:code` string that matches what the backend returns in
 * the login response (`response.capabilities`) and `/admin/auth/me/capabilities`.
 * The wildcard string `'*'` represents super-admin and is handled inside
 * `PermissionsService.hasCap`.
 *
 * If you change a tuple here, you MUST update the backend constant of the
 * same name in `backend/rbac/capabilities.js` AND the matching seed row in
 * `backend/rbac/seeds/*.sql`. The boot-time validator on the backend will
 * refuse to start if the registry and `menu_actions` table disagree.
 */
export const CAPS = Object.freeze({
  RBAC: Object.freeze({
    MANAGE: '/rbac:manage'
  }),
  TRAINING: Object.freeze({
    SLOTS: Object.freeze({
      MANAGE_OTHERS: '/training/slots:manage_others'
    }),
    BOOKING: Object.freeze({
      BOOK_FOR_TEAM: '/training/booking:book_for_team',
      L1_TIER: '/training/booking:l1_tier'
    })
  }),
  SALES: Object.freeze({
    LEADS: Object.freeze({
      VIEW_OWN: '/sales/leads:view_own',
      VIEW_TEAM: '/sales/leads:view_team',
      VIEW_ALL: '/sales/leads:view_all'
    }),
    BUSINESS_VALIDATION: Object.freeze({
      VIEW_OWN: '/sales/business:view_own',
      VIEW_TEAM: '/sales/business:view_team',
    }),
    DASHBOARD_L1: Object.freeze({
      VIEW: '/sales/dashboard/l1:view'
    }),
    DASHBOARD_L2: Object.freeze({
      VIEW: '/sales/dashboard/l2:view'
    }),
    DASHBOARD_L3: Object.freeze({
      VIEW: '/sales/dashboard/l3:view'
    }),
    DASHBOARD_BUSINESS_VALIDATION: Object.freeze({
      VIEW: '/sales/business-validation/dashboard/:view'
    }),
    TEAM: Object.freeze({
      VIEW_TEAM: '/sales/team:view_team',
      VIEW_MANAGER_TEAM: '/sales/team:view_manager_team'
    }),
    SCORE: Object.freeze({
      VIEW_L1: '/sales/score:view_l1',
      VIEW_L2: '/sales/score:view_l2'
    })
  })
});

export type Capability = string;

/** Convenience: dashboard access shape returned by the backend login response. */
export interface DashboardAccess {
  l1: boolean;
  l2: boolean;
  l3: boolean;
  l4: boolean;
}
